import React, { FC, ReactNode } from 'react';
import dynamic from 'next/dynamic';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const MediumScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <MediaQuery minWidth={1024} maxWidth={1440}>
      {children}
    </MediaQuery>
  );
};

export default MediumScreen;
